import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { propertiesApi as n } from "@maat/api-main";
//#region src/properties/usePropertiesQuery.ts
var r = (r) => t({
	queryKey: e.list(r),
	queryFn: () => n.getProperties(r)
});
//#endregion
export { r as usePropertiesQuery };
